import { render, staticRenderFns } from "./RadioExtendedNumText.vue?vue&type=template&id=92c52132&"
import script from "./RadioExtendedNumText.vue?vue&type=script&lang=js&"
export * from "./RadioExtendedNumText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports